import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildBudgetMovementsDatatableFilter,
  useBudgetMovementsDatatable,
} from 'generated/resources/datatable.graphql'
import { BudgetMovementFragment } from 'generated/resources/graphql'
import { uniqBy } from 'lodash'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  source: ReturnType<typeof useBudgetMovementsDatatable>
  movements: BudgetMovementFragment[]
}

const EmployeeFilter = ({ source, movements }: Props) => {
  const employees = movements.filter((x) => !!x.employee).map((x) => x.employee)
  const options = employees.map((employee) => {
    if (!employee) throw 'Error'
    return {
      label: employee.fullName,
      value: employee.id,
      component: (
        <Box gap="s8" flexDirection="row" alignItems="center">
          <Avatar label={employee.fullName} url={buildUrl(employee.avatar?.url)} size="s32" />
          <Text.Normal>{employee.fullName}</Text.Normal>
        </Box>
      ),
    }
  })

  return buildBudgetMovementsDatatableFilter(source, {
    path: 'employeeId',
    identifier: 'budgetMovements.employeeId',
    type: FilterType.Id,
    title: i18n.t('budgets.detail.tabs.spendings.table.filters.employee'),
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: uniqBy(options, 'value'),
      },
    ],
    default: true,
  })
}

export default EmployeeFilter
